<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection" >
                <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                    <el-form-item label="客户名称" prop="name">
                        <CustomerSelect ref="CustomerSelect" :customer-idss="searcherModel.name" v-model="searcherModel.name" @change="CustomerHandleChange"></CustomerSelect>
                    </el-form-item>
                    <el-form-item label="客户级别" >
                        <el-select v-if="levels" size="small" v-model="searcherModel.level" placeholder="请选择" >
                            <el-option v-for="(item,key) in levels" :key="key" :label="item" :value="key" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="产品筛选">
                        <el-select size="small" v-model="searcherModel.product_id" placeholder="请选择" >
                             <el-option v-for="(item, key) in products" :key="key" :label="item.name" :value="item.id">
                        </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最后成交时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.done_time"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <DistrictLinkage ref="DistrictLinkage" :provinceId="searcherModel.province_id"  :cityId="searcherModel.city_id" :districtId="searcherModel.district_id"  @change="handleChange($event)" ></DistrictLinkage>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                        <el-button size="small" @click="resetForm()">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-table :data="customers" style="width: 100%" class="tabTopBorder" v-loading="loading"  v-watermask>
                <el-table-column label="客户名称" prop="customer.name" >
                    <template slot-scope="scope">
                        <span class="el-dropdown-link customer-name" @click="toCustomer(scope.row)">
                                {{scope.row.customer.name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="customer.level_name" label="级别" width="60" ></el-table-column>
                <el-table-column prop="customer.district_names" label="所在地区"></el-table-column>
                <el-table-column prop="row" label="已购产品"  >
                    <template slot-scope="scope">
                        <div >【{{scope.row.state}}】{{scope.row.product_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="customer.type_name" label="类型"></el-table-column>
                <!-- <el-table-column prop="product_price" label="产品价格"></el-table-column> -->
                <el-table-column prop="class_num" label="班级数"></el-table-column>
                <el-table-column label="合同时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.contract_start_time}}-{{scope.row.contract_end_time}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="done_time" label="最后成交时间"></el-table-column>
                <el-table-column prop="customer.last_trace_created_at" label="最后跟进时间"></el-table-column>

                <el-table-column prop="customer.user.branch_name" label="所在部门"></el-table-column>
                <el-table-column label="业务员"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.customer.user && scope.row.customer.user.id == $store.getters.userId" ><!--@TODU-->
                            <img :src="user_avatar" style="border:0px;border-radius:10px;-webkit-border-radius:10px;">
                        </span>
                        <span v-else >
                            {{scope.row.customer.user?scope.row.customer.user.name:''}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import CustomerService from "~/services/customer";
    import UserSelect1 from "~/widgets/UserSelectCorp.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import user_avatar from '~/assets/usre-icon.png';
    import CommonService from "~/services/common";
    import Config from "~/config/params";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";

    export default {
        components: {
            UserSelect1,
            CustomerSelect,
            Pagination,
            Config,
            DistrictLinkage
        },
        data() {
            return {
                user_avatar,
                types: {},
                levels: {},
                searcherModel: {done_time:[]},
                products:[],
                product_types:Config.getType(),
                customers: [],
                loading: true,
                // 分页信息
                linkPage: null,
                //客户绑定，删除
                form: {
                	customer_ids: [],
	                user_id: '',
                },
	            formLabelWidth: '120px',
            };
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            // this.getCacheCondition();
        	let params = this.searcherModel;
            params['page'] = to.query["page"];
	        params['perPage'] = to.query["perPage"];
	        // this.setCacheCondition(params);
            this.initListData(params);
        },
        destroyed(){
            delete localStorage['/customers/done'+this.$store.getters.token];
        },
        created: function () {
            this.getProducts();
            if(this.searcherModel == null) {
                this.searcherModel = CustomerService.getModel();
            }
            this.searcherModel.province_id = this.$route.query["province_id"];
            this.searcherModel.city_id = this.$route.query["city_id"];
            this.searcherModel.district_id = this.$route.query["district_id"];


            this.types = CustomerService.getTypes(true);
            this.levels = CustomerService.getLevels(true);
            this.initListData(this.searcherModel);
            if(!this.Acs('/customers/bind')) {
                this.disabled = true;
                return;
            }
        },
        //监听$route, 路由有变化时，重载列表。
        watch: {
            $route: function (value, oldValue) {
	            this.resetFields();
                let params = this.searcherModel;
                params['page'] = this.$route.query["page"];
                params['perPage'] = this.$route.query["perPage"];
                // this.setCacheCondition(params);
                this.initListData(params);
            }
        },

        methods: {
            setCacheCondition(params){
                localStorage.setItem(this.$route.path+this.$store.getters.token,JSON.stringify(params));
            },
            getCacheCondition(){
                let customer_condition = JSON.parse(localStorage.getItem(this.$route.path+this.$store.getters.token));
                if(customer_condition && typeof  customer_condition == 'object'){

                    this.searcherModel = customer_condition;
                    return customer_condition;
                }
                return false;
            },
            getProducts(){
                CommonService.getProducts({
                    is_deleted: 0,
                    fields: 'id,name,price,code'
                }).then(res => {
                    this.products = res.data
                });
            },
            // 客户列表展示
            initListData(params = {}) {
                // loading 动画
                this.loading = true;
                let dtd;
                let $canSearch = params.name || params.province_id || params.city_id || params.district_id;
                if(!$canSearch){
                    this.loading = false;
                    this.$message({
                        message: "请输入客户名称或者选择所在地区进行搜索",
                        type: 'error'
                    });
                    return [];
                }
                dtd = CustomerService.getDone(params);
                dtd.then(res => {
                    this.customers =  res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })

            },

            // 筛选查询
            submitSearch() {
                // loading 动画
                this.syncSelectedDistrict();
                let params = {
                    name: this.searcherModel.name,
                    type: this.searcherModel.type,
                    level: this.searcherModel.level,
                    province_id: this.searcherModel.province_id,
                    city_id: this.searcherModel.city_id,
                    district_id: this.searcherModel.district_id,
                    product_type:this.searcherModel.product_type,
                    product_id:this.searcherModel.product_id,
                    done_time:this.searcherModel.done_time
                };
                let $canSearch = params.name || params.province_id || params.city_id || params.district_id;
                if(!$canSearch){
                    this.$message({
                        message: "请输入客户名称或者选择所在地区进行搜索",
                        type: 'error'
                    });
                    return [];
                }

                // this.setCacheCondition(params);
                this.initListData(params);
            },
            resetFields(){
                this.searcherModel = _.clone(_.extend(this.searcherModel, {
                    name: '',
                    type: '',
                    province_id: '',
                    city_id: '',
                    district_id: '',
                    product_id: '',
                    level: '',
                    product_type:'',
                    done_time:[]
                }));
                delete localStorage[this.$route.path];
            },
            // 重置筛选表单
            resetForm() {
                this.resetFields();
                this.$refs["form"].resetFields();
                this.$refs["DistrictLinkage"].reset();
                this.$refs['CustomerSelect'].reset();
                this.initListData();
            },
	        //业务员姓名远程搜索组件赋值
	        UserHandleChange(value) {
		        this.form.user_id = value;
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.name = object.value;
            },

            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.searcherModel.province_id = parseInt(value[0]) || 0;
                this.searcherModel.city_id = parseInt(value[1]) || 0;
                this.searcherModel.district_id = parseInt(value[2]) || 0;
            },
            syncSelectedDistrict() {
                const districtLinkage = this.$refs["DistrictLinkage"];
                if (!districtLinkage) {
                    return;
                }
                this.handleChange(districtLinkage.selectedOptions || []);
            },
            toCustomer(row){
               // let path = "/customers/view?id="+row.customer_id;
             /*   this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    },
                });*/
                let id = row.customer_id;
                if(row.customer.pid > 0){
                    id = row.customer.pid;
                }
                let routeData = this.$router.resolve({ path:"/customers/view?id=" + id, query: {  referer: this.$route.path } });
                window.open(routeData.href, '_blank');
            }
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .customer-name {
        cursor: pointer;
    }

    .customer-name:hover {
        color: #409EFF;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/done.vue